import CommonSettings from '@/common/utils/Settings';

export default class ForumSettings extends CommonSettings {}
